import {
  Input,
  Form,
  Select,
} from 'antd'
import React from 'react'

import TableSearch, { TableSearchProps } from '@/components/shared/table-search'
import {
  NormalStatus,
  normalStatusOptions,
} from '@/constants/normal-status'
import { selectAccessibleEmployees } from '@/redux/employee-selector'
import {
  createAppSelector,
  useAppSelector,
} from '@/redux/utils'

const { Item } = Form

const selector = createAppSelector(
  [selectAccessibleEmployees],
  (employees) => employees.map(({ id, name }) => ({
    value: id,
    label: name,
  })),
)

export interface SearchCreatorValues {
  name?: string
  status?: NormalStatus
  employeeId?: number
}

export default function SearchCreator({
  onSearch,
}: Pick<TableSearchProps<SearchCreatorValues>, 'onSearch'>) {
  const employeeOptions = useAppSelector(selector)

  return (
    <TableSearch<SearchCreatorValues> onSearch={onSearch}>
      <Item name="name" label="By Creator">
        <Input placeholder="Enter creator name" allowClear />
      </Item>
      <Item name="status" label="By Status" style={{ width: 200 }}>
        <Select options={normalStatusOptions} placeholder="Select status" allowClear />
      </Item>
      <Item name="employeeId" label="By Employee" style={{ width: 240 }}>
        <Select options={employeeOptions} placeholder="Select employee" allowClear />
      </Item>
    </TableSearch>
  )
}
